/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Station } from './Station';
import {
    StationFromJSON,
    StationFromJSONTyped,
    StationToJSON,
} from './Station';

/**
 * 
 * @export
 * @interface GetStations200Response
 */
export interface GetStations200Response {
    /**
     * 
     * @type {Array<Station>}
     * @memberof GetStations200Response
     */
    records?: Array<Station>;
}

/**
 * Check if a given object implements the GetStations200Response interface.
 */
export function instanceOfGetStations200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetStations200ResponseFromJSON(json: any): GetStations200Response {
    return GetStations200ResponseFromJSONTyped(json, false);
}

export function GetStations200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStations200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(StationFromJSON)),
    };
}

export function GetStations200ResponseToJSON(value?: GetStations200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(StationToJSON)),
    };
}

